import React, { useState, useEffect, useCallback } from "react";
import {
  List,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  Paper
} from "@mui/material";
import { API } from "aws-amplify";
import CategoryModal from "../../CategoryModal";
import ChildFiltersModal from "./ChildFiltersModal";
import { cleanupRowCount, evaluateField } from "../../../methods";
import EditIcon from '@mui/icons-material/Edit';

// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateCurrentField, updateRules } from "./simpleModeSlice";

// Custom Components
import FilterListItem from "./FilterListItem";
import { selectDatabase, selectMetadata } from "../../../features/settings/settingsSlice";

const SimpleFilters = ({
  selectedTable,
  modifiedRules,
  setModifiedRules,
  filterTranslations,
  setFilterTranslations,
  setCalculateCount,
  setQuery,
  setShouldQueryUpdate,
  filters,
  setFilters,
  openChildFilters,
  setOpenChildFilters,
  filterModalOpen,
  setFilterModalOpen,
  pastFilters,
  setState,
  showSql,
  setSnackbarInfo
}) => {
  const [fields, setFields] = useState([]);
  const [rules, setRules] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState();
  const [dataExist, setDataExist] = useState(false);
  const [init, setInit] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentField, setCurrentField] = useState();
  const [tableRowCount, setTableRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedFilterValue, setSelectedFilterValue] = useState();
  const [selectedFilter, setSelectedFilter] = useState();
  const [endingLabel, setEndingLabel] = useState("");
  const [resultType, setResultType] = useState("");
  const [currentParentFilter, setCurrentParentFilter] = useState();
  const [groupCombinator, setGroupCombinator] = useState("or");
  const [showModifyCategory, setShowModifyCategory] = useState(false);
  const [categoryId, setCategoryId] = useState(null);
  const [category, setCategory] = useState(null);
  const dispatch = useDispatch();
  const metadata = useSelector(selectMetadata);

  useEffect(() => {
    let arr = [];
    if (selectedTable && selectedTable !== selectedColumn) {
      const tableName = selectedTable.friendlyName;
      setFields([]);
      metadata.queryItems.forEach((category) => {
        if (
          category.category === tableName &&
          category.queryBuilderJSON.length > 0
        ) {
          arr.push(category);
        }
      });
      setFields(arr);

      const column = arr?.find((el) => el.category === tableName);

      if (column) {
        setSelectedColumn(column);
        setCategory(column);
        setRules(column.queryBuilderJSON);
        setCurrentField(evaluateField(column.column));
      }
    }
  }, [selectedTable]);

  const handleValueChange = async (val, field, phrase) => {
    try {
      setRules((prevState) => {
        return prevState.map((rule) => {
          let f = evaluateField(rule.field);
          if (f === field) {
            return { ...rule, value: val };
          }
          return rule;
        });
      });

      await rules.map(async (rule) => {
        if (rule.parentField === field) {
          const distinctJson = rule.distinctValueJSON(val, phrase);
          setLoading(true);
          const res = await API.post(
            "CRCRestAPI",
            "/api/v1/getDistinctColumnValues",
            {
              body: distinctJson,
            }
          );
          await rules.map(async (rule) => {
            if (rule.parentField === field) {
              const distinctJson = rule.distinctValueJSON(val, phrase);
              setLoading(true);
              const res = await API.post(
                "CRCRestAPI",
                "/api/v1/getDistinctColumnValues",
                {
                  body: distinctJson,
                }
              );

              if (res && res.success === true) {
                let apiRes = JSON.parse(res?.data);
                let data = JSON.parse(res?.data)?.response;
                let resCount = 0;
                //check to make sure the parentField is not undefined
                if (rule.parentField !== undefined) {
                  setRules((prevState) => {
                    return prevState.map((r) => {
                      if (
                        evaluateField(r.field) === evaluateField(rule.field)
                      ) {
                        let resultType = "";
                        let optionsColumn = "";
                        let options = [];

                        if (data && data.length > 0) {
                          resultType = data[0][r.dataTypeColumn];
                        } else {
                          resultType = r.dataTypeColumn;
                        }
                        const props = {
                          resultType,
                        };

                        if (resultType === undefined) {
                          optionsColumn = evaluateField(r.selectOptionsColumn);
                        } else {
                          optionsColumn = evaluateField(
                            r.selectOptionsColumn,
                            props
                          );
                        }

                        data?.map((item) => {
                          if (
                            Object.prototype.hasOwnProperty.call(
                              item,
                              optionsColumn
                            )
                          ) {
                            let keys = Object.keys(item);
                            if (keys.length > 1) {
                              options.push({
                                [Object.keys(item)[0]]: item[optionsColumn],
                                [Object.keys(item)[1]]: item[keys[1]],
                              });
                            } else {
                              options.push({
                                [Object.keys(item)[0]]: item[optionsColumn],
                              });
                            }
                          }
                        });
                        const c = cleanupRowCount(apiRes.rowCount);
                        setTableRowCount(c);
                        if (c > metadata.globalLimit) {
                          return {
                            ...r,
                            field: evaluateField(r.field, props),
                            dataType: evaluateField(r.dataType, props),
                            operators: evaluateField(r.operators, props),
                            selectOptions: options,
                            displayType: "Table",
                            rowCount: c,
                          };
                        } else {
                          return {
                            ...r,
                            field: evaluateField(r.field, props),
                            dataType: evaluateField(r.dataType, props),
                            operators: evaluateField(r.operators, props),
                            selectOptions: options,
                          };
                        }
                      }
                      return r;
                    });
                  });
                }
                setLoading(false);
              }
            }
          });

          setInit(false);
        }
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const getDistinctValues = (field, phrase, reRender = false) => {
    if (dataExist && reRender === false) return;

    setLoading(true);
    //reRender && setLoading(true);

    const foundField = rules.find(
      (rule) => evaluateField(rule.field) === evaluateField(field)
    );
    let foundParentField = null;
    let parentFieldValue = null;
    let body = {};
    if (foundField) {
      if (foundField.parentField && foundField.dependsOnParent) {
        foundParentField = rules.find(
          (r) => evaluateField(r.field) === foundField.parentField
        );
        parentFieldValue = foundParentField.value;
      }
      body = foundField.distinctValueJSON(parentFieldValue, phrase);
    } else {
      body = {
        dbType: "Snowflake",
        autoComplete: !!phrase,
        autoCompletePhrase: phrase,
        limit: metadata.globalLimit,
        columnNames: [{ columnName: field }],
      };
    }

    API.post("CRCRestAPI", "/api/v1/getDistinctColumnValues", { body })
      .then((res) => {
        if (res && res.success === true) {
          const apiRes = JSON.parse(res.data);
          const resCount = cleanupRowCount(apiRes.rowCount);
          const data = JSON.parse(res.data).response;
          setTableRowCount(resCount);

          setRules((prevState) => {
            return prevState.map((rule) => {
              if (evaluateField(rule.field) === field) {
                if (resCount > metadata.globalLimit) {
                  return {
                    ...rule,
                    selectOptions: data,
                    displayType: "Table",
                    rowCount: resCount,
                  };
                }
                return { ...rule, selectOptions: data };
              }
              return rule;
            });
          });
          setDataExist(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleOpenFilterModal = (field, id) => {
    if (id && id !== '') {
      setCategoryId(id);
      setShowModifyCategory(true);
    }
    else {
      setCategoryId(null);
      setShowModifyCategory(false);
    }

    if (field && field !== '') {
      if (!metadata || !metadata.queryItems) {
        console.warn('Metadata not available when opening filter modal');
        setSnackbarInfo({
          open: true,
          message: "Database metadata is still loading. Please try again.",
          severity: "warning"
        });
        return;
      }

      const foundCategory = metadata.queryItems.find((r) => r.category === field);
      if (!foundCategory) {
        console.warn(`Category ${field} not found in metadata`);
        setSnackbarInfo({
          open: true,
          message: "Category not found. Please refresh and try again.",
          severity: "error"
        });
        return;
      }

      const rule = foundCategory?.queryBuilderJSON;
      setCategory(foundCategory);
      setSelectedColumn(foundCategory);
      setRules(rule);
    }
    setFilterModalOpen(true);
  };

  const handleCloseFilterModal = () => {
    setCategoryId(null);
    setShowModifyCategory(false);
    setFilterModalOpen(false);
  };

  const handleOpenChildFilters = (row, filterValue, filter, category) => {
    if (filterValue === undefined) {
      filterValue = row?.value || "";
    }

    // Find the most current filter data from the current filters state using filter.id instead of just category
    const currentFilterFromState = filters.find(f => f.id === filter.id);

    // Also find the most current row data
    let currentRowFromState = row;
    if (currentFilterFromState && row?.id) {
      const foundRow = currentFilterFromState.rows?.find(r => r.id === row.id);
      if (foundRow) {
        currentRowFromState = foundRow;
      }
    }

    if (currentFilterFromState) {
      setCurrentParentFilter(currentFilterFromState);
    } else {
      setCurrentParentFilter(filter);
    }

    const foundFilter = metadata.queryItems.find((r) => r.category === category);
    if (foundFilter) {
      setSelectedFilter(foundFilter);
      setSelectedFilterValue(filterValue);
      setOpenChildFilters(true);
    }
  };

  const handleCloseChildFilters = () => {
    setOpenChildFilters(false);
    setDataExist(false);
  };

  const updateFiltersWithHistory = useCallback((updaterFunction) => {
    setFilters(prevFilters => {
      const newFilters = updaterFunction(prevFilters);
      return newFilters;
    });
  }, [setFilters]);

  const handleDeleteFilter = (row) => {
    updateFiltersWithHistory(prevFilters => {
      if (!prevFilters?.length) return prevFilters;

      // Handle single filter in single category case
      if (prevFilters.length === 1 && prevFilters[0].rows.length === 1) {
        if (prevFilters[0].rows[0].id === row.id) {
          return [];
        }
      }

      // Create deep copy and remove the specific row
      const filtersCopy = structuredClone(prevFilters);

      const updatedFilters = filtersCopy.map(category => {
        if (category.rows?.length > 0) {
          const updatedRows = category.rows.filter(item => item.id !== row.id);
          return { ...category, rows: updatedRows };
        }
        return category;
      });

      // Remove empty categories
      const finalFilters = updatedFilters.filter(category => category.rows.length > 0);

      setCalculateCount(true);
      return finalFilters;
    });
  };

  const handleCombinatorChange = (value, id) => {
    updateFiltersWithHistory(prevFilters => {
      return prevFilters.map(filter => {
        if (filter.id === id) {
          return { ...filter, combinator: value };
        }
        return filter;
      });
    });
  };

  console.log({ rules, filters, metadata })

  return (
    <Box
      component="div"
      sx={{ display: "flex", height: 'auto', maxHeight: showSql ? "65vh" : '83vh', overflow: "auto", width: '100%' }}
    >
      <List sx={{ width: '100%', padding: 2 }}>
        {filters?.length > 0 &&
          filters?.map((filter) => {
            return (
              <Paper
                key={filter.id || `${filter.category}-${JSON.stringify(filter.rows?.map(r => r.id) || [])}`}
                elevation={0}
                sx={{
                  mb: 2,
                  border: '1px solid rgba(0, 0, 0, 0.12)',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              >
                {/* Category Header */}
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'surface.subtle',
                    borderBottom: '1px solid',
                    borderBottomColor: 'divider',
                    borderLeft: `10px solid ${filter.color || '#04aeea'}`,
                    px: 2,
                    py: 1.5
                  }}
                >
                  <Typography variant="subtitle1" fontWeight={500}>
                    {filter.category}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Select
                      label="Combinator"
                      onChange={(e) => handleCombinatorChange(e.target.value, filter.id)}
                      variant="standard"
                      size="small"
                      value={filter.combinator}
                    >
                      <MenuItem value={"and"}>and</MenuItem>
                      <MenuItem value={"or"}>or</MenuItem>
                    </Select>
                    <Button
                      onClick={() => handleOpenFilterModal(filter.category, filter.id)}
                    >
                      Modify Filter
                    </Button>
                  </Box>
                </Box>
                {filter.rows?.map((row, index, array) => {
                  return (
                    <FilterListItem
                      row={JSON.parse(
                        JSON.stringify(row)
                          .replaceAll("[char(10)]", "")
                          .replaceAll("[char(13)]", "")
                          .replaceAll(/\[Ident\d+\]/gim, "")
                      )}
                      key={row.id}
                      filterKey={row?.key}
                      handleOpenChildFilters={handleOpenChildFilters}
                      handleDeleteFilter={handleDeleteFilter}
                      setFilters={setFilters}
                      parentArray={array}
                      parentIndex={index}
                      filters={filters}
                      filter={filter}
                      category={filter.category}
                      metadata={metadata}
                    />
                  );
                })}
              </Paper>
            );
          })}
      </List>
      <ChildFiltersModal
        open={openChildFilters}
        close={handleCloseChildFilters}
        selectedColumn={selectedColumn}
        selectedFilterValue={selectedFilterValue}
        loading={loading}
        setLoading={setLoading}
        filters={filters}
        setFilters={setFilters}
        setCalculateCount={setCalculateCount}
        selectedFilter={selectedFilter}
        endingLabel={endingLabel}
        resultType={resultType}
        metadata={metadata}
        currentParentFilter={currentParentFilter}
      />
      {filterModalOpen && (
        <CategoryModal
          filterModalOpen={filterModalOpen}
          setFilterModalOpen={setFilterModalOpen}
          handleCloseFilterModal={handleCloseFilterModal}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          rules={rules}
          setRules={setRules}
          tableRowCount={tableRowCount}
          field={currentField}
          getDistinctValues={getDistinctValues}
          handleValueChange={handleValueChange}
          loading={loading}
          setLoading={setLoading}
          filters={filters}
          setFilters={setFilters}
          pastFilters={pastFilters}
          selectedColumn={selectedColumn}
          selectedEntity={selectedTable}
          setCalculateCount={setCalculateCount}
          setEndingLabel={setEndingLabel}
          setResultType={setResultType}
          metadata={metadata}
          setSnackbarInfo={setSnackbarInfo}
          groupCombinator={groupCombinator}
          setGroupCombinator={setGroupCombinator}
          categoryId={categoryId}
          showModifyCategory={showModifyCategory}
          category={category}
        />
      )}
    </Box>
  );
};

export default SimpleFilters;
